import { connect } from 'react-redux';
import ElasticSearchResults from '../../components/investor/search/ElasticSearchResults';

const mapStateToProps = state => ({
  elasticSearchResults: state.elasticSearchResults,
});

export default connect(mapStateToProps)(ElasticSearchResults);
